import React from "react";
import { FiDownload } from "react-icons/fi";
import { Button } from "newui/components/Button";
import { buildAuditExportUrl } from "newui/features/RolesPermissions/api/rbac-api";
import type { AuditLogFilters } from "newui/features/RolesPermissions/types/RolesPermissions.type";

export interface AuditExportButtonProps {
	filters: Omit<AuditLogFilters, "page" | "per_page">;
}

/**
 * Triggers the CSV export by navigating directly to the backend export URL
 * (built with the current filters as query params). This is intentionally
 * NOT an axios/fetch call — the backend sets Content-Disposition: attachment
 * so the browser downloads the file itself. Doing this via fetch would
 * require the FE to manually reformat/save the response body, which the
 * brief explicitly disallows.
 */
export const AuditExportButton = ({ filters }: AuditExportButtonProps) => {
	const handleExport = () => {
		const url = buildAuditExportUrl(filters);
		const anchor = document.createElement("a");
		anchor.href = url;
		anchor.setAttribute("download", "");
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
	};

	return (
		<Button
			btntype="secondary"
			size="sm"
			onClick={handleExport}
			data-testid="audit-export-button"
		>
			<span className="pr-2">
				<FiDownload size={16} />
			</span>
			Export CSV
		</Button>
	);
};
